module.exports = __webpack_public_path__ + "static/media/travel1.2d41da93.jpg";